import React from 'react';

export default function HomeDashboard() {
    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">Welcome to Insync Ops Console</h1>
                <p className="text-gray-600 mb-8 max-w-2xl">
                    This centralised dashboard provides operational oversight for Insync Insurance systems.
                    Select a module from the sidebar to get started.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
                        <h3 className="font-semibold text-blue-900 mb-2">IES Overview</h3>
                        <p className="text-sm text-blue-700 mb-4">Monitor Insync Email Service (IES) traffic metrics, bounce rates, and spam reports.</p>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 opacity-70">
                        <h3 className="font-semibold text-gray-900 mb-2">Security Oversight</h3>
                        <p className="text-sm text-gray-600 mb-4">Coming soon: Centralised security alerts and access logging.</p>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg border border-gray-100 opacity-70">
                        <h3 className="font-semibold text-gray-900 mb-2">Partner Connectivity</h3>
                        <p className="text-sm text-gray-600 mb-4">Coming soon: API health checks and integration status.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
